module.exports = __webpack_public_path__ + "img/GEOPILOTOIMG.b163a794.jpg";